import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateStory, StoryDto, UpdateStory } from './storie-dto';


@Injectable({
  providedIn: 'root'
})
export class StorieEnigmiService {

  private url = `${environment.apiUrl}/storys`;

  constructor(private http: HttpClient) { }



  getAll(): Observable<StoryDto[]> {
    return this.http.get<StoryDto[]>(`${this.url}`);
  }

  create(data: CreateStory): Observable<StoryDto> {
    return this.http.post<StoryDto>(`${this.url}`, data);
  }

  read(id: string): Observable<StoryDto> {
    return this.http.get<StoryDto>(`${this.url}/${id}`);
  }

  update(id: string, data: UpdateStory): Observable<StoryDto> {
    return this.http.put<StoryDto>(`${this.url}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  getEnigmasByMission(missionId: string): Observable<any> {
    return this.http.get<any>(`${this.url}/mission/${missionId}`);
  }
}
